import React, { ReactElement, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getCurrentUserState } from '../../redux/configuration/currentUser/slice';
import { filterHelpLinksForUser } from '../../constants/utils';
import { HelpButton } from './index';

export interface HelpButtonContainerProps {
  links: HelpButtonLink[];
}

export function HelpButtonContainer({
  links,
}: HelpButtonContainerProps): ReactElement {
  const { t } = useTranslation();
  const userRoles = useSelector(getCurrentUserState).userRoles;

  const filteredLinks = useMemo(() => {
    return filterHelpLinksForUser({
      helpLinkLabelToHide: t('helpButtonLinks.demoCreationHelp'),
      links,
      userRoles: userRoles || [],
    });
  }, [links, userRoles, t]);

  return <HelpButton links={filteredLinks} />;
}
